// src/components/ScrollToTop.js
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();
    const prevPathnameRef = useRef(pathname);

    useEffect(() => {
        // Solo hacer scroll si realmente cambió la ruta (no en el primer render)
        if (prevPathnameRef.current !== pathname) {
            // Scroll inmediato al inicio
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'instant'
            });

            // Scroll adicional después de un breve delay para contenido asíncrono
            const timeout = setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 100);

            prevPathnameRef.current = pathname;

            return () => {
                clearTimeout(timeout);
            };
        } else {
            // Primera carga: solo un scroll suave
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
            prevPathnameRef.current = pathname;
        }
    }, [pathname]);

    return null;
};

export default ScrollToTop;

